import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'config';
import Logo from 'ui-component/Logo';
import { MENU_OPEN } from 'store/actions';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const defaultId = useSelector((state) => state.customization.defaultId);
    const dispatch = useDispatch();
    return (
        <ButtonBase
            disableRipple
            onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })}
            sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                width: { xs: '100%', sm: 'auto' },
                height: { xs: '40px', sm: '44px', md: '48px' },
                px: { xs: 1, sm: 1.5 },
                borderRadius: 1,
                transition: 'all 0.3s ease',
                '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.05)',
                    transform: 'scale(1.01)',
                }
            }}
        >
            <Logo />
        </ButtonBase>
    );
};

export default LogoSection;
